import React, { useContext } from 'react'
import { PrivilegeContext } from '../../../../../context/PrivilegesContext'
import { CRIcon } from '../../../../crRender'
import "./style.css"
import { toolTipAtrributes } from '../../../../../utils'

const BaseBtn = ({ onApply, icon, action, className, reqAction = "canGet" }) => {

    const { privileges } = useContext(PrivilegeContext)

    return <div {...toolTipAtrributes(action,"top")}> <CRIcon isRender={true} icon={icon} className={`table-action ${className}`} onClick={onApply} /></div>

}

export default BaseBtn